module.exports = __webpack_public_path__ + "img/quati_final-Medium.cbcb5331.webp";